import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CasteAndCrewService } from '../../../../services/caste_and_crew/caste_and_crew.service';
import { LoginService } from '../../../../services/login/login.service';
import { Loginshared } from '../../../../services/sharedservices/loginshared.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { errorMessages } from '../../../../configurations/errorMessages';
import { ToastrService } from 'ngx-toastr';
import { SessionHelper } from '../../../../services/localstorage';
import { SubscriptionService } from '../../../../services/subscription/subscription.service';
import { CommonService } from '../../../../services/common_Service/common.service';
import { CharacterService } from '../../../../services/character/character.service';
import { ProductConfigurationService } from '../../../../services/product_configuration/product_configuration.service';
import { DatePipe } from "@angular/common";

@Component({
    selector: 'app-addCoupon',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})
export class addCoupon implements OnInit {

    isCreateNewShow: boolean = true;
    isUserLoggedIn: boolean = false;
    isShowRedemption: boolean = false;
    now: any;
    createCoupon: FormGroup;
    errorMessages = errorMessages;
    createCastNCrewSubmitted: boolean = false;
    assetGroupList = [];
    producTypeList:any=[];
    ProducTypeDropdownList:any=[];
    mapProductTypeArrayTemp:any=[];
    primaryNavigationMappingFilter:any={};
    img: any = [];
    assetPath : any;
    professionList: any = [];
    id: any;
    update = false;
    loader: boolean = false;
    mapCastSettings: any = {};
    mapCastlist: any = [];
    mapCastDroplist
    liveEventList: any = [];
    shareMassage: any;
    contentReadyToReview: boolean = false;

    start:number=0;
    limit:number=10;

    rows:any=[];
    temp = [];


    index = 0;
    filterObj:any = {};
    infoObj:any = {};
    castList : any = [];

    dropdownSettings = {};

    //@Input() contentId:any;
    @Output() updateSend = new EventEmitter<any>();

    //New Code start
    @Input() set contentId(value: any) {

        if (value == 'reset') {

            this.resetForm();

        } else {

            //start code for hide create new button
            if (value != 'null') {
                this.showCreateNewButton('hide');
            }
            //end code for hide create new button
            this.onLoad(value);
        }

    }

    applyBlackTheme = localStorage.getItem('boolThemeFlag');

    constructor(private characterService: CharacterService, private subscriptionService: SubscriptionService, private commonService: CommonService, private toastrService: ToastrService, private productConfigurationService: ProductConfigurationService, private activatedRoute: ActivatedRoute, private loginSharedService: Loginshared, private loginService: LoginService, private router: Router, private casteAndCrewService: CasteAndCrewService, private formBuilder: FormBuilder) {
        loginSharedService.sendUserLoggedIn$.subscribe(
            mission => {
                this.isUserLoggedIn = mission;
                let uid = localStorage.getItem('ud');
                if (uid !== undefined && uid != null) {
                    this.isUserLoggedIn = true;
                }
            }
        );
    }

    roleAsses: any = {};
    roleConfiguration: any = [];
    ngOnInit() {
      const datePipe = new DatePipe('en-Us');
      this.now = datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.primaryNavigationMappingFilter.id = [];
      this.activatedRoute.params.subscribe((params: Params) => {
            this.assetPath = params['id'];
            console.log('LLLLLLL', this.assetPath, this.assetPath > 0)
            if(this.assetPath>0) {
              this.update = true;
              this.dropdownSettings = {
                disabled: true
              }
              this.onLoad(this.assetPath);
            } {
              this.update = false;
              this.onLoad('null');
            }
    });

        this.roleConfiguration = SessionHelper.getRole();

        // theme update code start
        this.commonService.currentThemelight.subscribe((result: any) => {

            this.applyBlackTheme = localStorage.getItem('boolThemeFlag');
            this.filterObj.languageId = localStorage.getItem('languageId');
            this.getAllSubscription(this.filterObj,0,10);

        })
        // theme update code start

        let uid = localStorage.getItem('ud');
        if (uid !== undefined && uid != null) {

        }   else {
            this.router.navigate(['/login']);
        }

        this.getAllCharacter({}, this.start, this.limit);

        // let headerTitle = {

        //     title:environment.masterPageTitle,
        //     subTitle:environment.mCharacterSubPage

        // }

        // this.commonService.changeHeaderTitle(headerTitle);
    }



    onLoad(id) {

        this.getGlobalProfession();

        let headerTitle = {
            title: 'Master',
            subTitle: 'Coupon'

        }

        this.commonService.changeHeaderTitle(headerTitle);

        // this.mapCastSettings = {

        //     singleSelection: true,
        //     text: "Select",
        //     selectAllText: 'Select All',
        //     unSelectAllText: 'UnSelect All',
        //     enableSearchFilter: true,
        //     classes: "myclass custom-class"

        // }
        this.mapCastSettings = {
          singleSelection: false,
          text:"Select Plan Zone",
          selectAllText:'Select All',
          unSelectAllText:'UnSelect All',
          enableSearchFilter: true,
          searchBy: ['name'],
          lazyLoading: true,
          maxHeight:130,
          minHeight:30,
          classes:"myclass custom-class"
      };

        let uid = localStorage.getItem('ud');

        if (uid !== undefined && uid != null) {

        } else {

            this.router.navigate(['/login']);
        }

        this.createCoupon = this.formBuilder.group({
            couponCode: ['', Validators.compose([Validators.required])],
            couponName: [''],
            redemptiontype: ['forever'],
            duration: [''],
            valid: [''],
            discounttype: [''],
            isactive: [true],
            discountvalue: [''],
            maxredemption: [''],
            mapsubMapping: [[]],
            id: [''],
            created_by: [localStorage.getItem('ud')]
        });

        this.id = id;

        if (this.id != 'null') {

            console.log('this.id===>>>', this.id);

            this.update = true;
            this.getCouponInfo(this.id)
        } else {

            this.update = false;

        }

        //   });
    }
    get l() { return this.createCoupon.controls; }

    saveCastNCrew() {

        this.createCastNCrewSubmitted = true;
    }

    getCouponInfo(id){

        // this.loader=true;
        this.commonService.changeloader(true);

        this.characterService.getCoupon(id)
        .subscribe((result:any)=>{

            // this.loader=false;
            this.commonService.changeloader(false);

            console.log("result==========>",result);

            this.createCoupon.controls['couponCode'].setValue(result.data[0].coupon_code);
            this.createCoupon.controls['couponName'].setValue(result.data[0].couponName);
            this.createCoupon.controls['discountvalue'].setValue(result.data[0].discount_value);
            this.createCoupon.controls['discounttype'].setValue(result.data[0].discount_type);
            this.createCoupon.controls['isactive'].setValue(result.data[0].isActive);
            this.modo(result.data[0].discount_type);
            this.createCoupon.controls['redemptiontype'].setValue(result.data[0].redemption_type);
            this.createCoupon.controls['maxredemption'].setValue(result.data[0].maxredemption);
            this.createCoupon.controls['duration'].setValue(result.data[0].duration);
            this.createCoupon.controls['valid'].setValue(result.data[0].valid);
            if(result.data[0].subMapping.length>0){

              this.mapProductTypeArrayTemp = [];
              this.primaryNavigationMappingFilter.id = [];

              for(let i = 0 ;i < result.data[0].subMapping.length;i++){
                  let obj={
                  'id':result.data[0].subMapping[i].subscriptionId,
                  'itemName':result.data[0].subMapping[i].title,
                  }
                  this.mapProductTypeArrayTemp.push(obj);
                  this.primaryNavigationMappingFilter.id.push(obj.id);
                  this.createCoupon.controls['mapsubMapping'].setValue(this.mapProductTypeArrayTemp);
              }

              this.getAllSubscription(this.primaryNavigationMappingFilter, 0, 10);
          }

            this.update = true;

            setTimeout(()=>{


            let obj = {

                'id':result.data[0].professionTypeId,
                'itemName':result.data[0].professionTypeName

            }

            this.createCoupon.controls['professionType'].setValue([obj]);

            let objS = {

                'id':result.data[0].cast[0].castId,
                'itemName':result.data[0].cast[0].firstName

            }

            this.createCoupon.controls['mapCast'].setValue([objS]);

            console.log("objS",objS);

            },1000)




            console.log("result==========>",result.data[0].isActive.toString());

        });
    }

    getGlobalProfession() {

        this.commonService.getGlobalProfession({}, 0, 1000).subscribe((result: any) => {

            this.professionList = [];

            if (result.data.data.length > 0) {

                for (let professionList of result.data.data) {

                    if (professionList.professionId != '') {

                        this.professionList.push(
                            {
                                'id': professionList.professionId,
                                'itemName': professionList.professionName
                            });
                    }
                }
            }

        });

    }

    modo(value: any) {
      console.log(value == 'event', value);
      if(value == 'event') {
        this.isShowRedemption = true;
      } else {
        this.isShowRedemption = false;
      }
    }

    onchange(event: Event){
        const value = (event.target as HTMLSelectElement).value;

        console.log(value == 'event',value);
        if(value == 'event') {
          this.isShowRedemption = true;
        } else {
          this.isShowRedemption = false;
        } 
    }


    getAllSubscription(obj,start,limit){

      this.loader=true;
      this.filterObj=obj;

      this.commonService.getGlobalTrailerVideo({},0,10000000)
      .subscribe((result:any)=>{
          this.loader=false;
          console.log('result===>',result);
          this.mapCastlist = [];

          this.ProducTypeDropdownList = [];


          let mapProductTypeArray = this.createCoupon.value.mapsubMapping;

          console.log("v",mapProductTypeArray);

          if(result.data.data.length > 0){


              this.ProducTypeDropdownList = result.data.data;
              console.log('...', this.ProducTypeDropdownList)
              for (let ProducTypeLists of this.ProducTypeDropdownList) {

                  if((mapProductTypeArray !='' && mapProductTypeArray !=[])){
                      mapProductTypeArray.forEach(element => {

                          if(element.id == ProducTypeLists.assetId) {

                              this.mapProductTypeArrayTemp.push(element);

                              this.mapProductTypeArrayTemp = this.removeDuplicates(this.mapProductTypeArrayTemp , "id");
                              this.primaryNavigationMappingFilter.id.push(element.id);
                              this.createCoupon.controls['mapsubMapping'].setValue(this.mapProductTypeArrayTemp);

                          }

                          this.mapProductTypeArrayTemp = this.removeDuplicates(this.mapProductTypeArrayTemp , "id");
                      });
                  }

                  if(ProducTypeLists.title!=''){

                          this.producTypeList.push(
                              {
                                  'id': ProducTypeLists.assetId,
                                  'itemName': ProducTypeLists.assetName
                              });
                  }

                  this.producTypeList = this.removeDuplicates(this.producTypeList , "id");

              }

          } else{


          }
      })

  }
    onItemSelect(item:any, mappingName){
     console.log('...', item, mappingName)

  console.log("this.createGenreForm.controls['mapProductType'",this.createCoupon.value.mapsubMapping);

  if(mappingName == 'mapsubMapping'){
      this.primaryNavigationMappingFilter.id.push(item.id);
      delete  this.primaryNavigationMappingFilter.keyword ;


   this.getAllSubscription(this.primaryNavigationMappingFilter,0,10);

  }

    }

    OnItemDeSelect(item:any, mappingName){

      if(mappingName == 'mapsubMapping'){

        console.log("this.primaryNavigationMappingFilter.id>>>",this.primaryNavigationMappingFilter.id);

        for (let index=0; index<this.primaryNavigationMappingFilter.id.length;index++){

            if(this.primaryNavigationMappingFilter.id[index] == item.id){

                this.primaryNavigationMappingFilter.id.splice(index, 1);

                if(this.primaryNavigationMappingFilter.id.length == 0){


                }else{

                   this.getAllSubscription(this.primaryNavigationMappingFilter,0,10);


                }


            }
        }
    }
    }

    onSelectAll(item:any, mappingName){

      if(mappingName == 'mapsubMapping'){

        console.log("this.primaryNavigationMappingFilter.productTypeId>>>",this.primaryNavigationMappingFilter.id);

        for (let index=0; index<this.primaryNavigationMappingFilter.id.length;index++){

            if(this.primaryNavigationMappingFilter.id[index] == item.id){

                this.primaryNavigationMappingFilter.id.splice(index, 1);

                if(this.primaryNavigationMappingFilter.id.length == 0){


                }else{

                  this.getAllSubscription(this.primaryNavigationMappingFilter,0,10);
                }


            }
        }
    }
    }

    onDeSelectAll(event, info){

      if(info =='mapsubMapping'){

        this.createCoupon.controls['mapsubMapping'].setValue([]);
        // this.mapMenuCategoryArrayTemp = [];
        // this.producTypeList = [];
        this.mapProductTypeArrayTemp =[];
        this.primaryNavigationMappingFilter.id = [];
        this.mapProductTypeArrayTemp
        this.producTypeList = [];
        this.mapProductTypeArrayTemp=[];


        // this.createCoupon.controls['mapMenuCategory'].setValue([]);
        // this.mapMenuCategoryArrayTemp = [];
        // this.menuCategoryList = [];
        // this.mapPrimaryNavigationArrayTemp=[];


        // this.createCoupon.controls['mapPrimaryNavigation'].setValue([]);
        // this.mapPrimaryNavigationArrayTemp = [];
        // this.primaryNavigationList = [];

    }
    }
    removeDuplicates(originalArray, prop) {

      var newArray = [];
      var lookupObject  = {};

      for(var i in originalArray) {
          lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for(i in lookupObject) {
          newArray.push(lookupObject[i]);
      }
          return newArray;
  }


    //New Code for right side for from
    onContentReadyToReview() {
        //code for global loader start
        // this.loader = false;
        this.commonService.changeloader(false);
        //code for global loader end

        if (this.createCoupon.invalid) {

            this.createCastNCrewSubmitted = true;
            return;

        }

        this.contentReadyToReview = true;
        this.shareMassage = 'character';

    }

    isContentReadyToReviewReceived(event) {

        console.log("we are in", event);
        this.contentReadyToReview = false;

        // New Code start
        if (event == 'No') {

            this.contentReadyToReview = false;

            this.shareMassage = '';

        }
        //New Code end

        if (event == 'Yes') {

            this.postCallCharacter();
            this.shareMassage = '';

        }
        if (event == 'Cancel') {

            // this.postCallCharacter();
            this.shareMassage = '';
            this.contentReadyToReview = false;
            //  this.saveCharacter();

        }

    }

    postCallCharacter(){
        if(!this.update){

            delete this.createCoupon.value.id;
            this.characterService.insertCoupon(this.createCoupon.value)
            .subscribe((result:any)=>{

                // this.spinnerService.hide();
                // this.router.navigate(['master/character/list']);
                 //New Code for right side for from
                 this.commonService.changeloader(false);
                 this.update = false;
             //    this.updateSend.emit();
                 this.resetForm();
                 this.createCastNCrewSubmitted = false;
                 this.router.navigate(['coupon/list']);
                this.toastrService.success('Coupon Created Successfully.');
            });
        }
        if(this.update){

            this.createCoupon.controls['id'].setValue(this.assetPath);
            console.log('..... update', this.createCoupon.value);
            this.characterService.updateCoupon(this.createCoupon.value)
            .subscribe((result:any)=>{


                 //New Code for right side for from
                 this.commonService.changeloader(false);
                 this.router.navigate(['coupon/list']);
                 this.toastrService.success('Coupon Updated Successfully.');
                 this.update = false;
                 this.resetForm();
                 this.createCastNCrewSubmitted = false;

                // this.spinnerService.hide();

            });
        }
    }

    getAllCharacter(obj , start , limit){

        this.loader=true;
        this.filterObj = obj;

        this.characterService.getAllCoupon(obj,start,limit)
        .subscribe((result:any)=>{

            this.loader=false;

            console.log('result===>',result.data.data);

            this.castList = [];

            if(obj.keyword != undefined){
                if(result.data.data.length == 0){
                    this.temp = [];
                    this.rows = [];
                    return;
                }
            }

            if(result.data.data.length > 0){

                //this.noRecordFound=false;
                // let index = 0;

                 // index value set on pagination below code
                 this.index = parseInt(localStorage.getItem("offset"));
                 // index value set on pagination above code


                for (let castObj of result.data.data) {
                    this.index++;

                    this.infoObj.pageCount =  result.data.pageCount ;
                    this.infoObj.totalCount = result.data.totalCount ;
                    this.infoObj.page = 'coupon';
                    // let strCast = '';

                    let editButton = "<a class='tableFaIconButtton'><img src='./../../../../../assets/images/edit.svg'></a>";
                    let deleteButton = "<a class='tableFaIconButtton'><img src='./../../../../../assets/images/delete.svg'></a>";
                    let isActiveStatus;

                    if(castObj.isActive == 1){
                        castObj.isActive='Active';
                        isActiveStatus = "<span class='activeStatus'>Active</span>";
                    }else{
                        castObj.isActive='Not Active';
                        isActiveStatus = "<span class='notactiveStatus'>Not Active</span>";
                    }


                    if(castObj.sameForAllZone == 1){
                        castObj.sameForAllZone='Yes';
                    }else{
                        castObj.sameForAllZone='Not';
                    }

                    // let modified_date = this.datePipe.transform(castObj.modified,"EEE, MM/d/y - hh:mm");

                    // let modifiedTime = moment(castObj.modified).format('HH.mm:ss');
                    // castObj.modified = moment(castObj.modified).format('YYYY-MM-DD');

                    let posterImage = "";
                    if(castObj.horizontalFilePath != null){

                        let front = "<img class='listingThumbnail' src='";
                        let back = "' alt='Poster Image'>";
                        posterImage = castObj.horizontalFilePath;

                    }else {

                        posterImage = "";
                    }

                    // this.castList.push(
                    // {
                    //     'srNo': this.index,
                    //     'id': castObj.characterId,
                    //     // 'thumbnail': posterImage,
                    //     'isDelete':this.roleAsses.characterDelete,
                    //     'isApprove':this.roleAsses.characterApprove,
                    //     'isUnapprove':this.roleAsses.characterUnApprove,
                    //     'isActivate':this.roleAsses.characterActivate,
                    //     'isDeactive':this.roleAsses.characterDeactivate,
                    //     'title': castObj.characterFirstName+' '+castObj.characterLastName,
                    //     'isActive': isActiveStatus,
                    //     'modified': castObj.modified,
                    //     'edit': editButton,
                    //     'delete': deleteButton
                    // });
                }
                // cache our list
                this.temp = this.castList;

                // push our inital complete list
                this.rows = this.castList;

            }
            else{

                this.rows = [];
                this.temp = [];
             //   this.noRecordFound=true;
            }
        })

    }

    resetForm() {

        this.updateSend.emit();

        this.createCoupon = this.formBuilder.group({

            couponCode: ['', Validators.compose([Validators.required])],
            couponName: [''],
            redemptiontype: [''],
            duration: [''],
            valid: ['1'],
            discounttype: [''],
            isactive: [true],
            discountvalue: [''],
            maxredemption: [''],
            mapsubMapping: [[]],
            id: [''],
            created_by: [localStorage.getItem('ud')]
        });

        this.update = false;

        this.showCreateNewButton('show');

    }

    showCreateNewButton(isShow) {
        if (isShow == 'show') {
            this.isCreateNewShow = true;
        }
        else {
            this.isCreateNewShow = false;
        }
    }

}
